import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Dropdown, Row, Col, Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import Navbar_Logo_LTR from "../../../assets/images/logo/Navbar_Logo_LTR.svg";
import Navbar_Logo_RTL from "../../../assets/images/logo/Navbar_Logo_RTL.svg";
import img_avatar from "../../../assets/images/img_avatar.png";
import LanguageToggler from "../LanguageToggler/LanguageToggler";
import { useTranslation } from "react-i18next";
import { authService } from "../../../services";
import IndividualImage from "../../../assets/images/registrationtype/individual.svg";
import CenterImage from "../../../assets/images/registrationtype/center.svg";
import {
  globalConstants,
  translationConstants,
  viewPathConstants,
  roles,
  StorageKeys,
  UserVerificationApprovalStatus,
  Directions,
} from "../../../constants";
import { useScreenWidth } from "../../hooks/windowResize";
import {} from "../../../constants";
import logout_img from "../../../assets/images/icon/logout.svg";
import user from "../../../assets/images/icon/user.svg";
import ChangePasswordModal from "../Modals/ChangePasswordModal";
import {
  clearUserData,
  getCurrentUserRole,
  getIsMobile,
  getLocalStorageItem,
  getSessionStorageItem,
  getUserPayload,
  setLocalStorageItem,
  setSessionStorageItem,
} from "../../../system";
import { Nav, Navbar, Offcanvas } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import {
  getAdminNavLinks,
  getCenterNavLinks,
  getGeneralUserNavLinks,
  GetInstructorNavLinks,
  getSuperAdminNavLinks,
  publicUserTopNavLinks,
  adminTopNavLinks,
  getPractitionerUserNavLinks,
} from "../SideBarContainer/utility";
import {
  HamburgerIcon,
  UserProfileIcon,
} from "../../../assets/images/icon/iconsProvider";
import TextSwitchButton from "../SwitchButton/TextSwitchButton";
import { authActions, systemActions } from "../../../redux/actions";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import AlreadyHaveAAccount from "../../../container/views/registeration/Components/AlreadyHaveAAccount";
import RegisterationDataForm from "../../../container/views/registeration/Components/RegisterationDataForm";
import CenterRegistrationForm from "../../../container/views/CenterRegistration/CenterRegistrationForm";
import DontHaveAAccount from "../DontHaveAAccount/DontHaveAAccount";
import BaseRegistrationForm from "../BaseRegistrationForm/BaseRegistrationForm";
import BaseForm from "../BaseForm/BaseForm";
import CustomModal from "../CustomModal/CustomModal";
import GeneralLogo from "../CompanyLogo/GeneralLogo";
import LoginForm from "../../../container/views/login/LoginForm";
import ForgotPassword from "../../../container/views/forgotPassword/ForgotPassword";
import ForgotPasswordForm from "../../../container/views/forgotPassword/ForgotPasswordForm";
import RegistrationSuccessModal from "../Modals/RegistrationSuccessModal";
import routes from "../../../system/routes";
import { logout } from "../../../redux/actions/auth.action";
import BaseChooseRegistration from "../BaseChooseRegistrationType/BaseChooseRegistration";
import BaseChooseRegistrationView from "../BaseChooseRegistrationType/BaseChooseRegistrationView";

NavBar.propTypes = {};

const mobileBrekpoint = globalConstants.SCREEN_BREAKPOINTS.md;
const mobileBrekpointString = "lg";
const getLogo = (i18n, showMobileLogo = false) => {
  return i18n.dir() === Directions.ltr ? Navbar_Logo_LTR : Navbar_Logo_RTL;
};

function NavBar(props) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const baseUrl = window.location.origin;
  const showLoginModal = useSelector(
    (state) => state.LoginReducer.showLoginModal
  );
  const language = localStorage.getItem("i18nextLng");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isShowLoginModal, setShowLoginModal] = useState(false);
  const [isShowRegistrationModal, setShowRegistraionModal] = useState(false);
  const [isShowCenterRegistrationModal, setShowCenterRegistraionModal] =
    useState(false);
  const [isShowChooseRegistrationModal, setShowChooseRegistrationModal] =
    useState(false);
  const [isShowforgotPassword, setShowForgotPasswordModal] = useState(false);
  const [isShowRegSuccessPassword, setShowRegSucessPasswordModal] =
    useState(false);

  //-------Useselectors
  const centerId = useSelector(
    (state) => state.LoginReducer.UserData?.user?.centerId
  );
  const userData = useSelector((state) => state.LoginReducer.UserData);
  const systemReducer = useSelector((state) => state.systemReducer);
  const publicNavLinks = [...publicUserTopNavLinks()];
  const [screenWidth] = useScreenWidth();
  const [logo, setLogo] = useState(getLogo(i18n));
  const [logoUrl, setLogoUrl] = useState(null);
  const userRole = getCurrentUserRole();
  const handleToggleSailorProfile = (value) => {
    dispatch(systemActions.toggleSailorProfile(value));
  };
  const isAuthenticated = useSelector(
    (state) => state.LoginReducer.isAuthenticated
  );
  useEffect(() => {
    setLogoUrl(
      userRole ? baseUrl : process.env.REACT_APP_MARKETING_SITE_URL + language
    );
  }, [userRole, language]);


  const getNavLinks = () => {
    let links = [];
    // userRole === roles.SuperAdmin || userRole === roles.Admin
    //   ? [...adminTopNavLinks()]
    //   : [...publicUserTopNavLinks()];

    const activeProfile = getLocalStorageItem(StorageKeys.activeRole);
    switch (userRole) {
      case roles.SuperAdmin:
        if (getIsMobile(mobileBrekpoint)) {
          links = [...getSuperAdminNavLinks(), ...links];
        }
        break;
      case roles.Admin:
        if (getIsMobile(mobileBrekpoint)) {
          links = [...getAdminNavLinks(), ...links];
        }
        break;
      case roles.GeneralUser:
        if (getIsMobile(mobileBrekpoint)) {
          links = [...getGeneralUserNavLinks(), ...links];
        }
        break;
      case roles.VerifiedUser:
        if (getIsMobile(mobileBrekpoint)) {
          links = [...getPractitionerUserNavLinks(), ...links];
        }
        break;
      case roles.Practioner:
        if (getIsMobile(mobileBrekpoint)) {
          links = [...getPractitionerUserNavLinks(), ...links];
        }
        break;
      case roles.Instructor:
      case roles.FreelanceInstructor:
        if (getIsMobile(mobileBrekpoint)) {
          if (activeProfile === 3) {
            links = [...getPractitionerUserNavLinks(), ...links];
          } else {
            links = [...GetInstructorNavLinks(userData), ...links];
          }
        }
        break;
      case roles.Center:
        if (getIsMobile(mobileBrekpoint)) {
          links = [...getCenterNavLinks(userData), ...links];
        }
        break;
      default:
        break;
    }

    return links;
  };

  const navLinks = getNavLinks();

  const [userFirstName, setuserFirstName] = useState("");
  const [isShow, setShow] = useState(false);

  const openModal = () => {
    handleSidebarMenu();
    setShow(true);
  };

  function handleLogout() {
    clearUserData();
    dispatch(logout());
    window.history.replaceState(null, null, viewPathConstants.DEFAULT_PATH);
  }

  useEffect(() => {
    setShowLoginModal(showLoginModal);
  }, [showLoginModal]);
  useEffect(() => {
    const storedUserData = getUserPayload();
    if (storedUserData) {
      if (storedUserData?.centerName) {
        setuserFirstName(
          i18n.dir() === Directions.rtl && storedUserData.centerName?.arabicName
            ? storedUserData.centerName?.arabicName
            : storedUserData.centerName?.name
        );
      } else if (storedUserData?.user) {
        setuserFirstName(
          i18n.dir() === Directions.rtl && storedUserData.user?.arabicFirstName
            ? storedUserData.user?.arabicFirstName
            : storedUserData.user?.englishFirstName
        );
      }
    }
    // eslint-disable-next-line
  }, [i18n.dir()]);

  useEffect(() => {
    setLogo(getLogo(i18n, props.showMobileLogo));
    // eslint-disable-next-line
  }, [screenWidth, props.showMobileLogo, i18n.dir()]);

  const navigateToProfile = () => {
    if (centerId) {
      navigate(`${viewPathConstants.CENTER_PROFILE}?id=${centerId}`);
    } else {
      navigate(viewPathConstants.PROFILE);
    }
  };
  useEffect(() => {
    if (isAuthenticated) {
      dispatch(authActions.setShowLoginModal(false));
    }
  }, [isAuthenticated]);
  //-------handle login click
  const handleLoginClick = () => {
    // handleSidebarMenu();
    // navigate(viewPathConstants.LOGIN);
    setShowLoginModal(!isShowLoginModal);
  };

  //-------handle Register click
  const handleRegisterClick = () => {
    // handleSidebarMenu();
    // navigate(viewPathConstants.REGISTRATION)
    // setShowRegistraionModal(!isShowRegistrationModal);
    setShowChooseRegistrationModal(!isShowChooseRegistrationModal);
  };

  //Save active role in localStorage
  const handleProfileToggle = () => {
    handleToggleSailorProfile(!systemReducer.isSailorProfile);
    const activeRole = systemReducer.isSailorProfile
      ? roles.Instructor
      : roles.Practioner;
    setLocalStorageItem(StorageKeys.activeRole, activeRole);
    if (
      activeRole === roles.Instructor &&
      userData?.instructorStatus === UserVerificationApprovalStatus.Disabled
    ) {
      navigate(viewPathConstants.DISABLED_INSTRUCTOR);
    }
  };
  const closeLoginModal = (isShowLogin) => {
    setShowLoginModal(isShowLogin);
    if (!isShowLogin) {
      dispatch(authActions.setShowLoginModal(false));
    }
  };
  const handleSidebarMenu = () => {
    setSidebarOpen(!sidebarOpen);
  };
  const handleShowForgotPassword = () => {
    setShowLoginModal(false);
    dispatch(authActions.setShowLoginModal(false));
    setShowForgotPasswordModal(true);
    setShowChooseRegistrationModal(false);
  };
  const handleShowRegistrationModal = () => {
    setShowLoginModal(false);
    dispatch(authActions.setShowLoginModal(false));
    setShowForgotPasswordModal(false);
    setShowRegistraionModal(true);
    setShowChooseRegistrationModal(false);
  };
  const handleShowChooseRegistrationModal = () => {
    setShowLoginModal(false);
    dispatch(authActions.setShowLoginModal(false));
    setShowForgotPasswordModal(false);
    setShowRegistraionModal(false);
    setShowCenterRegistraionModal(false)
    setShowChooseRegistrationModal(true);
  };
  const handleRegSuccessContinueModal = () => {
    setShowRegSucessPasswordModal(false);
    setShowRegistraionModal(false);
    setShowForgotPasswordModal(false);
    setShowCenterRegistraionModal(false);
    setShowChooseRegistrationModal(false);
  };
  const handleShowRegSuccessModal = () => {
    setShowCenterRegistraionModal(false);
    setShowRegistraionModal(false);
    setShowRegSucessPasswordModal(true);
    setShowChooseRegistrationModal(false);
  };
  const handlealreadyHaveAccount = () => {
    setShowForgotPasswordModal(false);
    setShowRegistraionModal(false);
    setShowCenterRegistraionModal(false);
    setShowLoginModal(true);
    setShowChooseRegistrationModal(false);
  };
  const handleRegisterasCenter = () => {
    setShowCenterRegistraionModal(true);
    setShowRegistraionModal(false);
    setShowChooseRegistrationModal(false);
  };
  return (
    <>
      {isShow && <ChangePasswordModal isShow={isShow} setShow={setShow} />}
      <Navbar
        key={mobileBrekpointString}
        expand={mobileBrekpointString}
        className="bg-body-tertiary m-0 p-0 background top-navbar d-flex justify-content-between"
        collapseOnSelect
      >
        <Navbar.Brand className="m-0 p-0 d-flex">
          <div className={`hamburger-menu-toggle-wrapper`}>
            {!getIsMobile(mobileBrekpoint) && !props.hideProfileIcon && (
              <button
                type="button"
                className="reset-to-default-button hamburger-icon-button mx-3 mx-lg-4"
                onClick={props.handleViewSidebar}
                aria-controls={`offcanvasNavbar-expand-${mobileBrekpointString}`}
              >
                <HamburgerIcon className={"hamburger-icon"} />
              </button>
            )}
            <div
              className={`d-flex justify-content-center align-items-center ${
                getIsMobile(mobileBrekpoint) && "px-3 px-lg-4"
              }`}
            >
              <Navbar.Toggle
                aria-controls={`offcanvasNavbar-expand-${mobileBrekpointString}`}
                onClick={() => handleSidebarMenu()}
              />
            </div>
          </div>
          <a href={logoUrl}>
            <img
              src={logo}
              alt="SAUDI SAILING FEDERATION"
              className={`${
                !getIsMobile(mobileBrekpoint) && props.hideProfileIcon && "mx-3"
              }`}
            ></img>
          </a>
        </Navbar.Brand>
        {getIsMobile(mobileBrekpoint) && (
          <Navbar.Offcanvas
            id={`offcanvasNavbar-expand-${mobileBrekpointString}`}
            aria-labelledby={`offcanvasNavbarLabel-expand-${mobileBrekpointString}`}
            placement={i18n.dir() === Directions.ltr ? "start" : "end"}
            show={sidebarOpen}
            onHide={() => setSidebarOpen(false)}
          >
            <Offcanvas.Header
              closeButton
              className="p-0 mx-3 d-flex justify-content-between"
            >
              {!props.hideProfileIcon ? (
                <div className="py-2 d-flex justify-content-start align-items-center gap-2">
                  <img
                    alt="Profile-Pic"
                    className="rounded-circle mobile-sidebar-profile-image"
                    src={img_avatar}
                  />
                  <span className="mobile-sidebar-profile-name">
                    {userFirstName}
                  </span>
                </div>
              ) : (
                <div className="d-flex justify-content-center align-items-center py-2 gap-3">
                  <div className="userprofile-icon-wrapper">
                    <UserProfileIcon />
                  </div>
                  <div className="d-flex justify-content-center align-items-center gap-2">
                    <button
                      type="button"
                      onClick={handleLoginClick}
                      className="reset-to-default-button login-signup-button"
                    >
                      {t(translationConstants.login)}
                    </button>
                    <div className="login-sign-up-seperator"></div>
                    <button
                      type="button"
                      onClick={handleRegisterClick}
                      className="reset-to-default-button login-signup-button"
                    >
                      {t(translationConstants.register)}
                    </button>
                  </div>
                </div>
              )}
            </Offcanvas.Header>
            <Offcanvas.Body className="h-100 p-0 mx-3">
              <div className="offcanvas-navlinks d-lg-none">
                <Nav
                  className={`justify-content-end align-items-${mobileBrekpointString}-center flex-grow-1 pe-3`}
                >
                  {getIsMobile(mobileBrekpoint) &&
                    navLinks.map((link) => (
                      <NavLink
                        key={link.path}
                        to={link.path}
                        className={"nav-link"}
                        onClick={() => handleSidebarMenu()}
                      >
                        {t(link.name)}
                      </NavLink>
                    ))}
                  {getIsMobile(mobileBrekpoint) && <hr></hr>}
                  {getIsMobile(mobileBrekpoint) &&
                    publicNavLinks.map((link) => (
                      <NavLink
                        key={link.path}
                        to={link.path}
                        className={"nav-link"}
                        onClick={() => handleSidebarMenu()}
                      >
                        {t(link.name)}
                      </NavLink>
                    ))}
                </Nav>
              </div>
              {getIsMobile(mobileBrekpoint) && !props.hideProfileIcon && (
                <div className="offcanvas-footer d-flex flex-column justify-content-end py-4 gap-2">
                  {(userRole === roles.Instructor ||
                    (userRole === roles.Practioner &&
                      userData?.instructorStatus ===
                        UserVerificationApprovalStatus.Disabled) ||
                    userRole === roles.FreelanceInstructor) && (
                    <div>
                      <TextSwitchButton
                        isChecked={systemReducer.isSailorProfile}
                        handleToggleSwitch={handleProfileToggle}
                        firstValue={translationConstants.instructor}
                        secondValue={translationConstants.PRACTITIONER}
                      />
                    </div>
                  )}
                  <div
                    className="logout-button-wrapper-mobile-menu"
                    onClick={openModal}
                  >
                    <i className="fa-solid fa-key size-14"></i>
                    <span className="logoutSidebar text-nowrap">
                      {t(translationConstants.CHANGE_PASSWORD)}
                    </span>
                  </div>
                  <div
                    className="logout-button-wrapper-mobile-menu"
                    onClick={handleLogout}
                  >
                    <img
                      alt="side-bar"
                      height={18}
                      width={18}
                      src={logout_img}
                    />
                    <span className="logoutSidebar text-nowrap">
                      {t(translationConstants.logout)}
                    </span>
                  </div>
                </div>
              )}
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        )}
        <div className="d-flex justify-content-end align-items-center pe-2 pe-lg-2 ps-2 ps-lg-0 gap-4">
          {!getIsMobile(mobileBrekpoint) && (
            <div className="d-flex justify-content-center align-item-center gap-4">
              {publicNavLinks.map((link) => (
                <NavLink key={link.path} to={link.path} className={"nav-link"}>
                  {t(link.name)}
                </NavLink>
              ))}
            </div>
          )}
          <LanguageToggler />
          {!getIsMobile(mobileBrekpoint) && (
            <>
              {!props.hideProfileIcon ? (
                <div
                  id="profileData"
                  className={`${props.hideProfileIcon ? "d-none" : "d-block"}`}
                >
                  <Dropdown>
                    <Dropdown.Toggle
                      id="profile-dropdown"
                      className="bg-transparent border-0 pe-0 d-flex ps-2 align-content-center align-items-center"
                    >
                      <span className="text-truncate text-truncate-charactor-limit-header">
                        {userFirstName}
                      </span>
                      <img
                        alt="Profile-Pic"
                        className="rounded-circle mx-1"
                        width={45}
                        height={45}
                        src={img_avatar}
                      ></img>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="navbar-dropdown-menu" flip="true">
                      <Dropdown.Item
                        eventkey="user-profile"
                        className="navbar-dropdown-link"
                        onClick={navigateToProfile}
                      >
                        <Row className="navbar-dropdown-item">
                          <Col xs="2">
                            <img
                              alt="side-bar"
                              className="size-14"
                              height={5}
                              width={5}
                              src={user}
                            />
                          </Col>
                          <Col xs="auto" className="navbar-container">
                            {t(translationConstants.myProfile)}
                          </Col>
                        </Row>
                      </Dropdown.Item>
                      <Dropdown.Item
                        eventkey="change-password"
                        className="navbar-dropdown-link"
                        onClick={openModal}
                      >
                        <Row className="navbar-dropdown-item">
                          <Col xs="2">
                            <i className="fa-solid fa-key size-14"></i>
                          </Col>
                          <Col xs="auto" className="navbar-container">
                            {t(translationConstants.CHANGE_PASSWORD)}
                          </Col>
                        </Row>
                      </Dropdown.Item>
                      <Dropdown.Item
                        eventkey="logout"
                        className="navbar-dropdown-link"
                        onClick={() => {
                          handleLogout();
                        }}
                      >
                        <Row className="navbar-dropdown-item">
                          <Col xs="2">
                            <img
                              alt="side-bar"
                              className="size-14"
                              height={5}
                              width={5}
                              src={logout_img}
                            />
                          </Col>
                          <Col xs="auto" className="navbar-container">
                            {t(translationConstants.logout)}
                          </Col>
                        </Row>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              ) : (
                <div className="d-flex justify-content-center align-items-center py-2 gap-3 px-2 ">
                  <div className="userprofile-icon-wrapper desktop-login-text">
                    <UserProfileIcon />
                  </div>
                  <div className="d-flex justify-content-center align-items-center gap-2">
                    <button
                      type="button"
                      onClick={handleLoginClick}
                      className="reset-to-default-button login-signup-button desktop-login-text"
                    >
                      {t(translationConstants.login)}
                    </button>
                    <div className="login-sign-up-seperator"></div>
                    <button
                      type="button"
                      onClick={handleRegisterClick}
                      className="reset-to-default-button login-signup-button desktop-login-text"
                    >
                      {t(translationConstants.register)}
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </Navbar>

      <CustomModal
        size="sm"
        show={isShowLoginModal}
        scrollable={true}
        setShow={closeLoginModal}
      >
        <BaseForm>
          <GeneralLogo />
          <LoginForm handleShowForgotPassword={handleShowForgotPassword} />
          <DontHaveAAccount
            handleShowChooseRegistrationModal={
              handleShowChooseRegistrationModal
            }
          />
        </BaseForm>
      </CustomModal>
      <CustomModal
        scrollable={true}
        size="lg"
        show={isShowRegistrationModal}
        setShow={setShowRegistraionModal}
        closeBtnClasses={"login-modal-close-btn"}
        onClose={handleShowChooseRegistrationModal}
        isMoveBack={true}
      >
        <BaseRegistrationForm>
          <GeneralLogo />
          <RegisterationDataForm
            handleShowRegSuccessModal={handleShowRegSuccessModal}
          />
          <AlreadyHaveAAccount
            handlealreadyHaveAccount={handlealreadyHaveAccount}
            handleRegisterasCenter={handleRegisterasCenter}
          />
        </BaseRegistrationForm>
      </CustomModal>
      <CustomModal
        scrollable={true}
        size="lg"
        show={isShowChooseRegistrationModal}
        setShow={setShowChooseRegistrationModal}
        closeBtnClasses={"login-modal-close-btn"}
   
      >
        <BaseChooseRegistration>
          <GeneralLogo />

          <BaseChooseRegistrationView
            setShowChooseRegistrationModal={setShowChooseRegistrationModal}
            setShowRegistraionModal={setShowRegistraionModal}
            setShowCenterRegistraionModal={setShowCenterRegistraionModal}
          />
          <AlreadyHaveAAccount
            handlealreadyHaveAccount={handlealreadyHaveAccount}
            handleRegisterasCenter={handleRegisterasCenter}
          />
        </BaseChooseRegistration>
      </CustomModal>
      <CustomModal
        size="lg"
        scrollable
        show={isShowCenterRegistrationModal}
        setShow={setShowCenterRegistraionModal}
        closeBtnClasses={"login-modal-close-btn"}
        isMoveBack={true}
        onClose={handleShowChooseRegistrationModal}
      >
        <BaseForm>
          <GeneralLogo />
          <CenterRegistrationForm
            handleShowRegSuccessModal={handleShowRegSuccessModal}
          />
        </BaseForm>
      </CustomModal>
      <CustomModal
        size="sm"
        scrollable={true}
        setShow={setShowForgotPasswordModal}
        show={isShowforgotPassword}
        closeBtnClasses={"login-modal-close-btn"}
      >
        <BaseForm>
          <GeneralLogo />
          <ForgotPasswordForm
            setShowForgotPasswordModal={setShowForgotPasswordModal}
          />
          <DontHaveAAccount
            handleShowRegistrationModal={handleShowRegistrationModal}
          />
        </BaseForm>
      </CustomModal>
      <CustomModal
        size="sm"
        scrollable={true}
        setShow={setShowRegSucessPasswordModal}
        show={isShowRegSuccessPassword}
        closeBtnClasses={"login-modal-close-btn"}
      >
        <BaseForm>
          <GeneralLogo />
          <RegistrationSuccessModal
            handleRegSuccessContinueModal={handleRegSuccessContinueModal}
          />
        </BaseForm>
      </CustomModal>
    </>
  );
}

export default NavBar;
